(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.fakeSearch = this.querySelector('.header__fake-search');
      this.fakeSearchInput = this.querySelector('.header__fake-search__bar__input');
      this.fakeSearchClose = this.querySelector('.header__fake-search__close');
      this.detailsModal = this.header.querySelector('details-modal');
      this.searchDetails = this.detailsModal.querySelector('#search-details');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.fakeSearchClose.addEventListener('click', () => {
        this.hideFakeSearch();
      });

      this.fakeSearchInput.addEventListener('focus', () => {
        this.searchDetails.click();
        this.hideFakeSearch(false);
      });

      if (document.body.dataset.template.includes('product') == false && document.body.dataset.template.includes('cart') == false) {
        this.openMobileSearch();
      }

      this.createObserver();
    }
ƒ
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const sexFilterFeaturedCollectionUsed = getCookie('sexFilterFeaturedCollectionUsed');
      if (sexFilterFeaturedCollectionUsed) {
        const timeDifference = new Date().getTime() - sexFilterFeaturedCollectionUsed;
        if (timeDifference < 500) return;
      }
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.remove('header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.detailsModal;
      this.searchModal.close(false);
    }

    openMobileSearch() {
      if (window.innerWidth < 500 && getCookie('closed-mobile-search') != 1 && !document.body.classList.contains('shop--only-browsing')) {
        document.querySelector('.header__fake-search').classList.add('header__fake-search--open');
        this.searchDetails.classList.add('hide');
      } else {
        this.searchDetails.classList.remove('hide');
        this.searchDetails.classList.add('blink');
      }
    }

    hideFakeSearch(setCookie = true) {
      this.fakeSearch.classList.remove('header__fake-search--open');
      this.searchDetails.classList.remove('hide');
      this.searchDetails.classList.add('blink');
      if (setCookie) {
        window.setCookie('closed-mobile-search', 1, 7);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function applyNavImages() {
      const cdnFiles = window.__ryzonNavCdnFiles;
      document.querySelectorAll('[data-nav-img]').forEach(function (el) {
        el.style.setProperty('--imgHandle', 'url(' + cdnFiles + el.dataset.navImg + '_120x.jpg)');
      });
      document.querySelectorAll('[data-nav-img-bg]').forEach(function (el) {
        el.style.backgroundImage = 'url(' + cdnFiles + el.dataset.navImgBg + '_600x.jpg)';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyNavImages);
    } else {
      applyNavImages();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-fbt"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              const list = recommendations.querySelector('ul.product-grid');
              const gender = this.dataset.gender;
              const limit = parseInt(this.dataset.limit, 10);

              if (list) {
                const items = Array.from(list.querySelectorAll('li.rzn-grid__item'));
                let itemsToShow = items;

                if (gender && gender !== 'unisex') {
                  const filteredItems = items.filter(item => item.dataset.sex === gender);
                  itemsToShow = filteredItems.length > 0 ? filteredItems : items;
                }

                if (!isNaN(limit)) {
                  itemsToShow = itemsToShow.slice(0, limit);
                }

                if (itemsToShow.length !== items.length) {
                  list.replaceChildren(...itemsToShow);
                }
              }

              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.rzn-grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-recos"] && !Shopify.designMode) return;
  try {
    
  const testRecosSection = document.querySelector('.test-recos');

  fetch(testRecosSection.dataset.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.test-recos');

      if (recommendations && recommendations.innerHTML.trim().length) {
        testRecosSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(e => {
      console.error(e);
    });

  } catch(e) { console.error(e); }
})();
})();
